'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Cell = _interopDefault(require('../cell'));
var SmsButton = _interopDefault(require('../sms-button'));
var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "form-item"
    }, [_c('cell', [_vm.options && _vm.onSelect ? _c('div', {
      staticClass: "form-select",
      style: _vm.labelStyle
    }, [_c('select', {
      domProps: {
        "value": _vm.selected
      },
      on: {
        "change": _vm.onSelect
      }
    }, _vm._l(_vm.options, function (item, index) {
      return _c('option', {
        key: item,
        domProps: {
          "value": index
        }
      }, [_vm._v(_vm._s(item))]);
    }), 0)]) : _vm.label ? _c('label', {
      staticClass: "form-label",
      style: _vm.labelStyle,
      attrs: {
        "for": _vm.uid
      }
    }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : void 0, _vm._v(" "), _c('input', {
      staticClass: "form-input",
      attrs: {
        "id": _vm.uid,
        "type": _vm.type,
        "maxLength": _vm.maxLength,
        "placeholder": _vm.placeholder,
        "readonly": _vm.readonly
      },
      domProps: {
        "value": _vm.formatValue
      },
      on: {
        "input": _vm.onInput,
        "focus": _vm.onFocus,
        "blur": _vm.onBlur
      }
    }), _vm._v(" "), _vm.clear ? _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.showClear,
        expression: "showClear"
      }],
      staticClass: "form-clear",
      on: {
        "touchstart": function touchstart($event) {
          $event.preventDefault();

          _vm.$emit('input', '');
        },
        "touchend": function touchend($event) {
          $event.preventDefault();

          _vm.$emit('clear');
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm.icon ? _c('i', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }, {
        name: "show",
        rawName: "v-show",
        value: !_vm.showClear,
        expression: "!showClear"
      }],
      class: ['form-icon', "icon-".concat(_vm.icon, "-outline"), "icon-".concat(_vm.icon)],
      on: {
        "click": function click($event) {
          $event.stopPropagation();

          _vm.$emit('clickIcon');
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm.smsButton ? _c('sms-button', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      attrs: {
        "status": _vm.smsButton
      },
      on: {
        "reset": function reset($event) {
          _vm.$emit('resetSMS');
        }
      },
      nativeOn: {
        "click": function click($event) {
          _vm.$emit('clickSMS');
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm.buttonText ? _c('span', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      staticClass: "sms-btn",
      on: {
        "click": function click($event) {
          $event.stopPropagation();

          _vm.$emit('clickButton');
        }
      }
    }, [_vm._v(_vm._s(_vm.buttonText))]) : _vm._e()], 2), _vm._v(" "), _vm.errorMessage ? _c('div', {
      staticClass: "form-error",
      domProps: {
        "textContent": _vm._s(_vm.errorMessage)
      }
    }) : _vm._e()], 1);
  },
  staticRenderFns: [],
  name: 'form',
  props: {
    value: {
      type: String,
      required: true
    },
    type: String,
    icon: String,
    label: String,
    clear: Boolean,
    format: String,
    options: Array,
    selected: Number,
    readonly: Boolean,
    maxLength: Number,
    smsButton: String,
    placeholder: String,
    errorMessage: String,
    regExp: RegExp,
    formatter: Function,
    labelWidth: String,
    buttonText: String
  },
  components: {
    Cell: Cell,
    SmsButton: SmsButton
  },
  data: function data() {
    return {
      focused: false,
      prevValue: '',
      // 生成组件unique id
      uid: Math.random()
    };
  },
  computed: {
    showClear: function showClear() {
      return !!this.value && this.focused;
    },
    formatValue: function formatValue() {
      return this.addSpace(this.value);
    },
    labelStyle: function labelStyle() {
      return {
        minWidth: this.labelWidth
      };
    }
  },
  mounted: function mounted() {
    this.prevValue = this.formatValue;
  },
  methods: {
    onInput: function onInput(event) {
      var _this = this;

      var input = event.target;

      if (!this.regExp && !this.format && !this.formatter) {
        this.$emit('input', input.value);
        return;
      }

      var value = input.value;
      var regExp = this.regExp || /\s/g;
      value = value.replace(regExp, '');

      if (this.formatter) {
        value = this.formatter(value);
      }

      var selectionPos = input.selectionEnd; // hack for 红米 webview

      if (value.length === 1 && selectionPos === 0) {
        selectionPos = 1;
      }

      var limitValue = this.getLimitValue(value);
      this.$emit('input', limitValue);
      this.$nextTick(function () {
        var isDelete = _this.prevValue.length >= _this.formatValue.length;
        var val = _this.formatValue;
        _this.prevValue = _this.formatValue;

        if (!isDelete) {
          selectionPos += val[selectionPos - 1] === ' ' ? 1 : 0;
        }

        setTimeout(function () {
          input.value = _this.formatValue;
          input.selectionStart = input.selectionEnd = selectionPos;
        }, 0);
      });
    },
    getLimitValue: function getLimitValue(value) {
      if (this.format && this.maxLength && this.format.length >= this.maxLength) {
        var trimFormat = this.format.substr(0, this.maxLength).replace(/\s/g, '');
        return value.substr(0, trimFormat.length);
      }

      return value;
    },
    onFocus: function onFocus() {
      if (!this.readonly) {
        this.focused = true;
        this.$emit('focus');
      }
    },
    onBlur: function onBlur() {
      if (!this.readonly) {
        this.focused = false;
        this.$emit('blur');
      }
    },
    onSelect: function onSelect(event) {
      this.$emit('select', parseInt(event.target.value));
    },
    addSpace: function addSpace(value) {
      if (this.format) {
        var res = '';
        var index = 0;

        for (var i = 0, pos = 0, len = this.format.length; i < len; i++) {
          if (!value[pos]) {
            break;
          }

          if (this.format[i] === ' ') {
            res += ' ';
          } else {
            index++;
            res += value[pos++];
          }
        }

        return res + value.substr(index);
      }

      return value;
    }
  }
});

exports.default = index;
